export const fontFamilyBoathouse = "\"Boathouse\", \"Noto Sans\", \"Segoe UI\", \"Helvetica Neue Extended\", -apple-system, system-ui, BlinkMacSystemFont, Roboto, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
export const fontFamilyBoathouseExtended = "\"BoathouseExtended\", \"Noto Sans\", \"Segoe UI\", \"Helvetica Neue Extended\", -apple-system, system-ui, BlinkMacSystemFont, Roboto, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
export const fontFamilyBoathouseCondensed = "\"BoathouseCondensed\", \"Noto Sans\", \"Segoe UI\", \"Helvetica Neue Extended\", -apple-system, system-ui, BlinkMacSystemFont, Roboto, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
export const fontWeightBold = "700";
export const fontWeightDemi = "600";
export const fontWeightMedium = "500";
export const fontWeightBook = "400";
export const lineHeightScaleSm = "100%";
export const lineHeightScaleMd = "110%";
export const lineHeightScaleLg = "130%";
export const lineHeightScaleXl = "150%";
export const lineHeightScale2xl = "170%";
export const fontSizeScale = "1.125"; // scale token used to create our typescale ramp - we use Major third scale
export const fontSizeBase = "1rem"; // 1rem // base units for typescaling
export const fontSize3xs = ".625rem"; // 10px
export const fontSize2xs = ".75rem"; // 12px
export const fontSizeXs = ".875rem"; // 14px
export const fontSizeSm = "1rem"; // 16px
export const fontSizeMd = "1.25rem"; // 20px
export const fontSizeLg = "1.5rem"; // 24px
export const fontSizeXl = "2rem"; // 32px
export const fontSize2xl = "3rem"; // 48px
export const fontSize3xl = "4rem"; // 64px
export const fontSize4xl = "5rem"; // 80px
export const fontSize5xl = "6rem"; // 96px
export const letterSpacingScaleNone = "0";
export const letterSpacingScaleSm = "-0.02em";
export const letterSpacingScaleMd = "0.01em";
export const letterSpacingScaleLg = "0.02em";
export const letterSpacingScaleXl = "0.04em";
export const letterSpacingScale2xl = "0.08em";
export const letterSpacingScale3xl = "0.16em";
export const letterSpacingScale4xl = "0.24em";
export const typeCasingNormal = "none";
export const typeCasingAllCaps = "uppercase";
export const typeCasingTitle = "capitalize";
export const textDecorationNone = "none";
